import { render, staticRenderFns } from "./brief-preview.vue?vue&type=template&id=9e16cd8a&scoped=true"
import script from "./brief-preview.vue?vue&type=script&lang=js"
export * from "./brief-preview.vue?vue&type=script&lang=js"
import style0 from "./brief-preview.vue?vue&type=style&index=0&id=9e16cd8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e16cd8a",
  null
  
)

export default component.exports